import {motion} from "framer-motion";
import styled from "styled-components";

export const Container = styled.div`
  position: relative;
`;

export const List = styled(motion.div)`
  top: 50px;
  z-index: 99;
  display: flex;
  padding: 0.3rem;
  border-radius: 5px;
  position: absolute;
  flex-direction: column;
  box-shadow: 0px 2px 3px 1px rgba(0, 0, 0, 0.1);
  background-color: ${({theme}) => theme["container"]};
`;

export const ListItem = styled.div`
  display: grid;
  padding: 1rem;
  cursor: pointer;
  align-items: center;
  border-bottom: 0.5px solid ${({theme}) => theme["line"]};

  &:hover {
    background-color: ${({theme}) => theme["hover"]};
  }
  &:active {
    transform: scale(0.99);
  }
  &:first-child {
    border-radius: 5px 5px 0 0;
  }
  &:last-child {
    border-bottom: unset;
    border-radius: 0 0 5px 5px;
  }
`;
